import * as React from 'react';

import { cn } from '../../styles/lib/utils';

const TextArea = React.forwardRef<HTMLTextAreaElement, React.ComponentProps<'textarea'>>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        ref={ref}
        data-slot="textarea"
        className={cn(
          'min-h-16 w-full min-w-0 rounded border bg-white px-2 py-1 text-xs leading-[1.4] text-grey-80 placeholder:text-grey-50 transition-[color,box-shadow,border-color] outline-none',
          'border-grey-30',
          'focus-visible:border-focus',
          'disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-grey-10',
          'aria-invalid:border-destructive aria-invalid:ring-destructive/20',
          'dark:bg-white/30 dark:aria-invalid:ring-destructive/40',
          className,
        )}
        {...props}
      />
    );
  },
);

TextArea.displayName = 'TextArea';

export { TextArea };
